module.exports = __webpack_public_path__ + "static/media/popup_mobile-tablet.f63b2eb5.png";